module.exports = __webpack_public_path__ + "static/media/ic_直播.eaa1659c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_直播.svg
// module id = 204
// module chunks = 0